import Vue from 'vue';
import Router from 'vue-router';
import LastVideos from '@/components/LastVideos';
import AllVideos from '@/components/AllVideos';
import VideoPage from '@/components/VideoPage';
import RGPD from '@/components/RGPD';
import Search from '@/components/Search';
import OldVideoPage from '@/components/OldVideoPage';

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: LastVideos,
    },
    {
      path: '/videos/:type/:id?/:page/:title',
      name: 'AllVideos',
      component: AllVideos,
    },
    {
      path: '/videos/:id/:slug',
      name: 'VideoPage',
      component: VideoPage,
    },
    {
      path: '/video/:id/:slug',
      name: 'OldVideoPage',
      component: OldVideoPage,
    },
    {
      path: '/:query?',
      name: 'Search',
      component: Search,
    },
    {
      path: '/rgpd',
      name: 'RGPD',
      component: RGPD,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js